import { Button, Divider } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { FaHome } from "react-icons/fa";
import { IoIosArrowDown, IoIosArrowUp, IoMdAnalytics } from "react-icons/io";
import { MdMenuBook, MdOutlineAdminPanelSettings, MdOutlineBusiness, MdOutlineEvent } from "react-icons/md";
import { WiSmoke } from "react-icons/wi";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import canLogo from "../assets/canna42logo.png";
import styles from "../styles/header.module.css";
import { AuthenticationInstance } from "../utils/authenticationClass";
import { BusinessInstance } from "../utils/businessClass";
import { HeaderTabList } from "./headerTabList";

const tabs = [
  {
    icon: <FaHome size={20} />,
    title: "Home",
    navigation: "/",
  },
  {
    icon: <WiSmoke size={20} />,
    title: "Products",
    navigation: "/products",
  },
  {
    icon: <MdMenuBook size={20} />,
    title: "Menu",
    navigation: "/menu",
  },
  {
    icon: <IoMdAnalytics size={20} />,
    title: "Analytics",
    // navigation: '/analytics',
    dropDown: [
      {
        title: "Follower Analytics",
        navigation: "/analytics/followers",
      },
    ],
  },
  {
    icon: <MdOutlineAdminPanelSettings size={20} />,
    title: "Admin",
    navigation: "/admin",
  },
  {
    icon: <MdOutlineBusiness size={20} />,
    title: "Settings",
    navigation: "/settings",
  },
  {
    icon: <MdOutlineEvent size={20} />,
    title: "Experiences",
    navigation: "/experiences",
  },
];

export const Header = () => {
  const navigate = useNavigate();
  const { activeBusiness, businesses, businessType } = useSelector((state: any) => state.business);
  const { isAdmin } = useSelector((state: any) => state.user);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (dropdownOpen && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  const handleNavigate = (navigation: string) => {
    navigate(navigation);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLogout = () => {
    AuthenticationInstance.handleSignOut();
  };

  const selectBusiness = async (business: any) => {
    // Dispatch an action to set the active business
    // dispatch(setActiveBusiness(business));
    await BusinessInstance.setBusiness(business);
    toggleDropdown();
    navigate("/");
  };

  // Filter tabs based on businessType and isAdmin
  const filteredTabs = tabs.filter((tab) => {
    if (tab.title === "Admin" && (!isAdmin || activeBusiness.name !== "canna42")) {
      return false;
    }
    if (businessType === "brand" && tab.navigation === "/menu") {
      return false;
    }
    if (businessType === "venue" && tab.navigation === "/products") {
      return false;
    }

    // if businessType is venue, add /analytics/checkins to the analytics dropdown
    if (businessType === "venue" && tab.title === "Analytics") {
      tab.dropDown = [
        {
          title: "Follower Analytics",
          navigation: "/analytics/followers",
        },
        {
          title: "Check-in Analytics",
          navigation: "/analytics/checkins",
        },
        {
          title: "Check-out Analytics",
          navigation: "/analytics/checkouts",
        },
      ];
    }

    if (businessType === "brand" && tab.title === "Analytics") {
      tab.dropDown = [
        {
          title: "Follower Analytics",
          navigation: "/analytics/followers",
        },
        {
          title: "Product Analytics",
          navigation: "/analytics/products",
        },
      ];
    }

    return true;
  });

  return (
    <div className={`${styles.wrapper} ${styles.maxWidth}`}>
      {/* CANNA42 LOGO */}
      <div className={styles.cannaWrapper}>
        <img src={canLogo} alt="canna42 logo" />
      </div>

      {/* CENTER TABS */}
      <HeaderTabList tabs={filteredTabs} navigate={handleNavigate} />

      {/* BUSINESS DROPDOWN AND NAME DISPLAY */}
      <div className={styles.businessWrapper} onClick={toggleDropdown} ref={dropdownRef}>
        {dropdownOpen ? <IoIosArrowUp size={20} /> : <IoIosArrowDown size={20} />}
        <h3>{activeBusiness.name}</h3>
        <img src={activeBusiness.avatarUrl} alt="company logo" />
        {dropdownOpen && (
          <div className={styles.dropdown}>
            {businesses.map((business: any) => (
              <div
                className={styles.businessBox}
                style={{
                  // if business.mondayHours then set backgroundColor to green else blue
                  border: business.businessType === "brand" ? "2px solid #f6861f" : "2px solid #0f9547",
                  borderRadius: "5px",
                }}
                key={business.id}
                onClick={() => selectBusiness(business)}
              >
                <img
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    marginRight: "10px",
                  }}
                  src={business[business.businessType].avatarUrl}
                  alt=""
                />

                <p
                  style={{
                    width: 175,
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                  }}
                >
                  {business[business.businessType].name}
                </p>
              </div>
            ))}
            <Divider />
            <Button onClick={handleLogout} sx={{ color: "grey.500" }} variant="text" fullWidth>
              Log Out
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
